import React from 'react'
import { SimpleListItemSkeleton } from '@app/components/placeholders'
import { Skeleton } from '@app/components/placeholders/skeleton'

export const EmptyPayments = () => {
  return (
    <div className='flex-1 flex flex-col'>
      <ul className='list-none pt-6 w-full'>
        <li className='pb-6'>
          <Skeleton className={'h-20 w-[100%]'} />
        </li>
        <SimpleListItemSkeleton full />
      </ul>
    </div>
  )
}
